import React from 'react';
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Row, Col, Button } from 'reactstrap';
import { Form, FormGroup, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { SelectField } from '../../../../../components';

let HostForm = ({ handleSubmit, pristine, submitting, isLoading, initialValues }) => {
    const { t } = useTranslation();

    return (
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <h5 className="text-italic">{t('hosts.restart_pihyve_after_saving_these_options')}</h5>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup row>
                            <Label for="options.disable_printers_manager" sm={4}>{t("hosts.printers_manager")}</Label>
                            <Col sm={8}>
                                <SelectField name="options.disable_printers_manager" options={[
                                    {text: t('hosts.enable_printers_manager'), value: false },
                                    {text: t('hosts.disable_printers_manager'), value: true },
                                ]} />
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup row>
                            <Label for="options.disable_efts_manager" sm={4}>{t("hosts.efts_manager")}</Label>
                            <Col sm={8}>
                                <SelectField name="options.disable_efts_manager" options={[
                                    {text: t('hosts.enable_efts_manager'), value: false },
                                    {text: t('hosts.disable_efts_manager'), value: true },
                                ]} />
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <Button type="submit" color="success" disabled={pristine || submitting || isLoading}>
                            {isLoading ?
                                <span>
                                    &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                </span>
                                :
                                <span>
                                    <i className="fa fa-save"></i>&nbsp;
                                    {t("common.save")}
                                </span>
                            }
                        </Button>
                    </Col>
                </Row>
            </Form>
    );
}

const mapDispatchToProps = {}
HostForm = reduxForm({
    form: 'hostForm',
    enableReinitialize: true,
    destroyOnUnmount: true
})(HostForm)
HostForm = connect(state => ({}), mapDispatchToProps)(HostForm)

export default HostForm;
